import { render, staticRenderFns } from "./UpdateClient.vue?vue&type=template&id=559c54b2&scoped=true&"
import script from "./UpdateClient.vue?vue&type=script&lang=js&"
export * from "./UpdateClient.vue?vue&type=script&lang=js&"
import style0 from "./UpdateClient.vue?vue&type=style&index=0&id=559c54b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c54b2",
  null
  
)

export default component.exports